import React, { Fragment, useState } from 'react';
import classNames from 'classnames';

import { buildFullLocation } from 'utils';

import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import CareerClusterHeaderTitle from '../careerClusterHeader/CareerClusterHeaderTitle';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

const CareerComboSalaryClusterHeader = ({ subPageName, subTitle, ...data }) => {
  const { title, city, stateAbbr, state } = data.criteria;
  const { locationDisplay } = data;
  const [pageTitle, setPageTitle] = useState('');

  const location = buildFullLocation(city, state, stateAbbr);

  return (
    <Fragment>
      <div className="job-title-search container d-flex flex-column-reverse flex-lg-row align-items-start">
        <CareerClusterHeaderTitle
          title={`${title} Salary In ${location}`}
          getPageTitle={(_pageTitle) => setPageTitle(_pageTitle)}
        />
        <SearchBar
          subPageName={subPageName}
          clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
          jobLocation={locationDisplay}
          className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
            'z-mt-lg-44': pageTitle.length > 40,
            'z-mt-lg-40': pageTitle.length <= 40,
          })}
        />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </Fragment>
  );
};

export default CareerComboSalaryClusterHeader;
